import * as React from 'react';
import './popup.css';
export class Popup extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.contentClose.addEventListener("click", () => {
            this.containerEl.style.display = 'none';
        });
    }
    render() {
        return (React.createElement("div", { className: "olPopup", ref: el => this.containerEl = el },
            React.createElement("a", { className: "olPopupCloser", href: "javascript:void(0)", ref: el => this.contentClose = el }),
            React.createElement("div", { className: "olPopupContents", ref: el => this.contentEl = el })));
    }
    setContents(html) {
        this.contentEl.innerHTML = html;
    }
    show(bottomDistance = '12px') {
        this.containerEl.style.bottom = bottomDistance;
        this.containerEl.style.display = 'block';
    }
}